import { gql, useMutation } from '@apollo/client';
import { CheckIcon } from '@heroicons/react/solid';
import { useEffect } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Account_AccountData_account } from '../../../types/graph/Account_AccountData';

// const tiers = [
//   {
//     name: 'Free Forever',
//     href: '#',
//     priceMonthly: 0,
//     description: 'All the basics for your first listing',
//     includedFeatures: ['1 Active Listing', 'Default tour branding'],
//   },
//   {
//     name: 'Self Serve',
//     href: '#',
//     priceMonthly: 46,
//     description: 'The features to get you going',
//     includedFeatures: [
//       '5 Active Listings',
//       'Add videos, 3D tours, floor plans',
//       'Choose your brand colors',
//     ],
//   },
//   {
//     name: 'White Glove',
//     href: '#',
//     priceMonthly: 197,
//     description: 'Fully managed service to save you time',
//     includedFeatures: [
//       '5 Active Listings',
//       'Websites created for you',
//       'Social media posts created for you',
//       'Live chat lead messaging',
//     ],
//   },
// ];

interface IProps {
  account: Account_AccountData_account;
  products: any[];
}

const SubscriptionGrid: React.FC<IProps> = ({ account, products }) => {
  const [tiers, setTiers] = useState<any[]>([]);
  const { pathname } = useLocation();

  useEffect(() => {
    let tiers = [];
    for (const product of products) {
      if (product.recurrence === 'monthly') {
        tiers.push(product);
      }
    }
    setTiers(tiers);
  }, [products, setTiers]);

  const [createCheckoutSession] = useMutation(CREATE_CHECKOUT_SESSION, {
    onCompleted: (data) => {
      //redirect
      console.log(data);
      window.location.replace(data.createCheckoutSession.url);
    },
  });

  const handleCheckout = (product: any) => {
    createCheckoutSession({
      variables: {
        accountId: account.id,
        input: { items: [{ ...product }] },
        redirect: pathname,
      },
    });
  };

  return (
    <div className="mt-4 bg-white">
      <div className="mx-auto py-0 px-0">
        <div className="sm:flex sm:flex-col sm:align-center"></div>
        <div className="mt-8 space-y-4 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-4 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 xl:grid-cols-3">
          {tiers?.length > 0 &&
            tiers.map((tier: any, idx: number) => (
              <div
                key={tier.name}
                className="border border-gray-200 rounded-lg shadow-sm divide-y divide-gray-200"
              >
                <div className="p-6">
                  <h2 className="text-lg leading-6 font-medium text-gray-900">
                    {tier.name}
                  </h2>
                  <p className="mt-4 text-sm text-gray-500">
                    {tier.description}
                  </p>
                  <p className="mt-8">
                    <span className="text-4xl font-extrabold text-gray-900">
                      ${tier.amount / 100}
                    </span>{' '}
                    <span className="text-base font-medium text-gray-500">
                      /mo
                    </span>
                  </p>
                  {!tier.active ? (
                    <button
                      className="mt-8 w-full items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
                      onClick={() => handleCheckout(tier)}
                    >
                      Upgrade
                    </button>
                  ) : (
                    <div className="mt-8 block w-full bg-gray-100 border border-gray-300 rounded-md py-2 text-sm font-semibold text-gray-400 text-center">
                      Current Plan
                    </div>
                  )}
                </div>
                <div className="pt-6 pb-8 px-6">
                  <h3 className="text-xs font-medium text-gray-900 tracking-wide uppercase">
                    What's included
                  </h3>
                  <ul className="mt-6 space-y-4">
                    {tier.features.map((feature: string) => (
                      <li key={feature} className="flex space-x-3">
                        <CheckIcon
                          className="flex-shrink-0 h-5 w-5 text-green-500"
                          aria-hidden="true"
                        />
                        <span className="text-xs text-gray-500">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionGrid;

const CREATE_CHECKOUT_SESSION = gql`
  mutation AccountBilling_createCheckoutSession(
    $accountId: String!
    $input: CartInput!
    $redirect: String!
    $listingId: String
  ) {
    createCheckoutSession(
      accountId: $accountId
      input: $input
      redirect: $redirect
      listingId: $listingId
    ) {
      url
    }
  }
`;
